<template>
  <div class="minHead">
    <div class="user_info flex-between">
      <div class="user flex-rowl">
        <div class="tx flex-rowc">
          <van-image
            class="img"
            width="98%"
            height="98%"
            round
            fit="cover"
            :src="
              userInfo.headimg
                ? userInfo.headimg
                : require('../assets/images/user-tx.png')
            "
          />
          <h5-cropper
            class="uploadInput"
            :option="option"
            @getFile="handleChooseImg"
          ></h5-cropper>
          <div class="edit flex-rowc">
            <i class="iconfont icon-zhaoxiangji"></i>
          </div>
        </div>
        <div class="main">
          <div class="nick">
            {{ userInfo.nickname ? userInfo.nickname : "" }}
          </div>
          <div class="name">
            {{ userInfo.truename ? userInfo.truename : "" }}
          </div>
          <div class="leavel_accountId flex-rowl">
            <p>
              {{ userInfo.levelid ? "LV-" + userInfo.levelid : "" }} |
              {{ userInfo.attrname ? userInfo.attrname : "" }}
            </p>
            <p class="accountId">
              ID：{{ userInfo.accountid ? userInfo.accountid : "" }}
            </p>
            <div
              class="copy_box"
              :data-clipboard-text="userInfo.accountid"
              @click="handleCopyBtn"
            >
              <i class="iconfont icon-fuzhi"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="edit" @click="handleEdit">
        <i class="iconfont icon-edit"></i>
      </div>
      <!-- <div class="tags flex-rowl">
        <div class="tag flex-rowc user_auth_icon active">买手认证</div>
        <div class="tag flex-rowc company_auth_icon">商家认证</div>
      </div> -->
    </div>
    <div class="line"></div>
  </div>
</template>

<script>
import Clipboard from "clipboard";
import { uploadImage } from "../api/api";
import { updateUserNickTx } from "../api/user";
import H5Cropper from "vue-cropper-h5";
export default {
  name: "my_head",
  components: { H5Cropper },
  props: {
    userInfo: {
      typeof: Object
    }
  },
  data() {
    return {
      option: {}, //配置
    };
  },
  created() {
  },
  methods: {
    handleEdit() {
      this.$router.push("/userIndex/userEdit");
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".copy_box");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$toast.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$toast.fail("复制失败");
        } else {
          this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },

    // 修改用户头像
    handleUpload() {
      let userInfo = this.$store.state.USERINFO;
      let params = {
        openid: userInfo.openid,
        nickname: userInfo.nickname,
        headimg: userInfo.headimg,
      };
      updateUserNickTx(params).then((res) => {
        console.log(res);
      });
    },
    // 上传图片
    handleChooseImg(data) {
      const toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      const formData = new FormData();
      formData.append("imgfile", data);
      uploadImage(formData).then((res) => {
        if (res.result) {
          this.userInfo.headimg = res.url;
          toast.clear();
          this.handleUpload();
        } else {
          this.$toast.fail("上传失败");
        }
      });
    },
  },
};
</script>

<style lang='less' scoped>
.minHead {
  .user_info {
    padding: 45px 0 0;
    margin: auto;
    width: 670px;
    .img {
      position: absolute;
    }
    .tx {
      width: 140px;
      height: 140px;
      border: 5px solid #f0f0f0;
      box-sizing: border-box;
      border-radius: 50%;
      // overflow: hidden;
      margin-right: 25px;
      position: relative;
      .edit {
        position: absolute;
        bottom: 7px;
        right: 9px;
        background: #f0f0f0;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        .iconfont {
          font-size: 12px;
        }
      }
      .uploadInput {
        position: relative;
        z-index: 10000000001;
      }
    }
    .main {
      flex: 1;
      .nick {
        font-size: 22px;
        color: #828282;
      }
      .name {
        font-size: 30px;
        color: #3c3c3c;
        margin: 12px 0 14px;
      }
      .leavel_accountId {
        font-size: 16px;
        color: #aaaaaa;
        .accountId {
          margin: 0 13px 0 45px;
        }
      }
    }
    .tags {
      font-size: 18px;
      color: #fff;
      margin-top: 16px;
      padding-left: 164px;
      box-sizing: border-box;
      .tag {
        width: 160px;
        height: 35px;
        text-align: center;
        line-height: 35px;
        border-radius: 18px;
        background: #bebebe;
        margin-right: 10px;
        &.active {
          background: #ff4200;
        }
      }
      .user_auth_icon::before {
        display: inline-block;
        content: "";
        background: url(../assets/images/user_auth_icon.png) no-repeat center;
        background-size: cover;
        width: 25px;
        height: 20px;
        margin-right: 10px;
      }
      .company_auth_icon::before {
        display: inline-block;
        content: "";
        background: url(../assets/images/company_auth_icon.png) no-repeat center;
        background-size: cover;
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
    }
    .edit {
      .iconfont {
        font-size: 32px;
        color: #868686;
      }
    }
  }
  .line {
    background: url(../assets/images/mime_line.png) no-repeat center;
    background-size: cover;
    width: 750px;
    height: 86px;
    margin: 28px 0 60px;
  }
}
</style>